export default __webpack_public_path__ + "static/media/ford.8e44a53f.svg";